import SimpleTooltip from './SimpleTooltip';

export {
  SimpleTooltip,
}
